import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{attrs:{"color":"authsidebar-bg primary darken4 secondary--text text-h4 text-center font-weight-medium background--primary px-8 d-none d-md-flex align-center justify-center","height":"100%"}},[_c('p',{staticClass:"sidebar--text"},[_vm._v("\n    Sistema de"),_c('br'),_vm._v("Gestão"),_c('br'),_vm._v("\n    Adminstrativa\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }